if (!customElements.get('ff-tabs-faq')) {
  customElements.define('ff-tabs-faq', class FfTabsFaq extends HTMLElement {
  constructor(){
    super();
    this.blocksTitle = this.querySelectorAll(".block-title") 
    this.addEvents();
  }

  addEvents(){
    if (this.blocksTitle.length !== 0) {
      this.blocksTitle.forEach((title)=>{
        title.addEventListener('click',()=>{
          if (title.nextElementSibling.classList.contains("ff-hide-element")) {
            title.nextElementSibling.classList.remove("ff-hide-element")
            title.children[1].children[0].classList.add("ff-hide-element")
            title.children[1].children[0].classList.remove("ff-show-element")
            title.children[1].children[1].classList.remove("ff-hide-element")
            title.children[1].children[1].classList.add("ff-show-element")
          }else{
            title.nextElementSibling.classList.add("ff-hide-element")
            /* title.children[1].children[0] plus icon */
            /* title.children[1].children[1] minus icon */
            title.children[1].children[0].classList.remove("ff-hide-element")
            title.children[1].children[0].classList.add("ff-show-element")
            title.children[1].children[1].classList.add("ff-hide-element")
            title.children[1].children[1].classList.remove("ff-show-element")

          }
        })
      })
    }
  }
});
}
